var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOpen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119.7 94.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dcb998;}.cls-2{fill:#c5a07d;}.cls-3{fill:#ececec;}.cls-4{fill:#c8cad1;}.cls-5{fill:#c07145;}.cls-6{fill:#f18956;}.cls-7{fill:#ded6ce;}.cls-10,.cls-8,.cls-9{fill:none;stroke-miterlimit:10;}.cls-8{stroke:#a3866a;}.cls-9{stroke:#f2dac5;}.cls-10{stroke:#fdebdd;}.cls-11{fill:#f2dac5;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "BoxOpen_02a",
    "data-name": "BoxOpen_02a",
    viewBox: "0 0 119.7 94.43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.3 16.85 53.2 39.88 59.85 37.72 59.85 1.72 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.75 24.76 59.85 37.72 59.85 1.72 99.75 24.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.21,32.7a1.6,1.6,0,0,0-.91-1.2l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7,7,0,0,0-5.14.35,1.11,1.11,0,0,0-.64.93h0l0,1.88-.14.08a1.38,1.38,0,0,0-.8,1.16h0l0,1.67-.13-.07V16.9h0c0-.52-.59-1-1.63-1.34a7,7,0,0,0-5.14.4c-.44.29-.65.61-.63.94h0v1.88l-.14.07A1.41,1.41,0,0,0,47.88,20h0v1.6l-.09-.05V19.64h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,0-.14.07,1.4,1.4,0,0,0-.78,1.18h0v1.59l-.09-.05V22.37h0c0-.51-.59-1-1.63-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.89l-.14.07A1.43,1.43,0,0,0,31,25.5h0v1.6l-.09-.05V25.11h0c0-.51-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.11,1.11,0,0,0-.62.94h0V27l-.13.08a1.36,1.36,0,0,0-.79,1.17h0v1.6l-.09-.05V27.85h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,1-.14.07A1.4,1.4,0,0,0,14.19,31h0V43.12h0c0,.65.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a10,10,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.67,2.12.65,5,.43,6.43-.5A1.38,1.38,0,0,0,50,58.48h0v-1.6a4.79,4.79,0,0,0,1.22.54,8.81,8.81,0,0,0,6.42-.5,1.4,1.4,0,0,0,.78-1.18h0v-1.6a4.71,4.71,0,0,0,1.21.54,8.8,8.8,0,0,0,6.42-.5A1.39,1.39,0,0,0,66.89,53h0V51.41a5.28,5.28,0,0,0,1.21.53c2.13.65,5,.43,6.43-.5a1.39,1.39,0,0,0,.78-1.17h0v-1.6a4.91,4.91,0,0,0,1.21.54c2.12.64,5,.42,6.42-.51a1.38,1.38,0,0,0,.79-1.17h0V45.94a4.79,4.79,0,0,0,1.11.5c2.12.67,5,.48,6.43-.43a1.38,1.38,0,0,0,.8-1.17h0l.13-12.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 61.02,
    cy: 14.35,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.35 75.04) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 52.51,
    cy: 17.09,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.86 69.41) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 44.09,
    cy: 19.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.79 63.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 35.66,
    cy: 22.56,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.72 57.98) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 27.24,
    cy: 25.3,
    rx: 1.31,
    ry: 2.96,
    transform: "matrix(0.01, -1, 1, 0.01, 1.65, 52.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 18.81,
    cy: 28.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-9.42 46.54) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 67.67,
    cy: 18.19,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(48.02 85.45) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 59.16,
    cy: 20.93,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(37.6 79.86) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 50.74,
    cy: 23.66,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(26.53 74.14) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 42.31,
    cy: 26.4,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(15.46 68.42) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 33.89,
    cy: 29.14,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(4.39 62.71) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 25.46,
    cy: 31.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-6.68 56.99) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 74.32,
    cy: 22.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(50.69 95.85) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 65.81,
    cy: 24.76,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(40.34 90.3) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 57.39,
    cy: 27.5,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(29.27 84.59) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 48.96,
    cy: 30.24,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(18.19 78.87) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 40.54,
    cy: 32.98,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(7.12 73.15) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 32.11,
    cy: 35.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-3.95 67.44) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 80.97,
    cy: 25.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(53.35 106.26) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 72.46,
    cy: 28.6,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(43.07 100.75) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 64.04,
    cy: 31.34,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(32 95.03) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 55.61,
    cy: 34.08,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(20.93 89.32) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 47.19,
    cy: 36.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(9.86 83.6) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 38.76,
    cy: 39.55,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-1.21 77.89) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 87.62,
    cy: 29.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(56.02 116.66) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 79.11,
    cy: 32.44,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.81 111.2) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 70.69,
    cy: 35.18,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.74 105.48) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 62.26,
    cy: 37.92,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.67 99.77) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 53.84,
    cy: 40.65,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.6 94.05) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 45.41,
    cy: 43.39,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(1.53 88.33) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.8,13.82h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 60.95,
    cy: 13.82,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(46.47 74.62) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.45,17.66h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 67.6,
    cy: 17.66,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(49.21 85.07) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.1,21.5h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 74.25,
    cy: 21.5,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(51.95 95.52) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.75,25.34h0c0-.54-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.06,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 80.9,
    cy: 25.34,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(54.69 105.96) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.4,29.18h0c0-.54-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.06,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 87.55,
    cy: 29.18,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(57.42 116.41) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.44,16.37h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.18,1.18,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 52.58,
    cy: 16.37,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(35.64 68.78) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.09,20.21h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.17,1.17,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 59.23,
    cy: 20.21,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(38.38 79.22) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.74,24.05h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.19,1.19,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 65.88,
    cy: 24.05,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(41.12 89.67) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.39,27.89h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.17,1.17,0,0,0-.65,1h0V30h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 72.53,
    cy: 27.89,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(43.86 100.12) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83,31.73h0c0-.54-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0V33.8h0c0,.54.62,1.06,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 79.18,
    cy: 31.73,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(46.6 110.57) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.07,18.92h0c0-.53-.62-1.06-1.71-1.39A7.3,7.3,0,0,0,41,18a1.17,1.17,0,0,0-.66,1h0V21h0c0,.54.62,1.07,1.71,1.4A7.3,7.3,0,0,0,47.41,22a1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 44.21,
    cy: 18.92,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 24.81, 62.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.72,22.76h0c0-.53-.62-1.06-1.71-1.39a7.25,7.25,0,0,0-5.34.42,1.17,1.17,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 50.86,
    cy: 22.76,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 27.55, 73.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.37,26.6h0c0-.53-.62-1.06-1.71-1.39a7.3,7.3,0,0,0-5.34.41,1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 57.51,
    cy: 26.6,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 30.29, 83.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68,30.44h0c0-.53-.62-1.06-1.71-1.39a7.3,7.3,0,0,0-5.34.41,1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 64.16,
    cy: 30.44,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 33.03, 94.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.67,34.28h0c0-.54-.62-1.06-1.71-1.39a7.3,7.3,0,0,0-5.34.41,1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.06,1.71,1.4A7.3,7.3,0,0,0,74,37.33a1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 70.81,
    cy: 34.28,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 35.77, 104.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.7,21.47h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.61,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.19,1.19,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 35.85,
    cy: 21.47,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 13.99, 57.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.35,25.31h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.61,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.19,1.19,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 42.5,
    cy: 25.31,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 16.72, 67.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53,29.15h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.13,1.13,0,0,0-.65,1h0v2.07h0c0,.54.61,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.19,1.19,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 49.15,
    cy: 29.15,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 19.46, 77.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.65,33h0c0-.53-.62-1.06-1.7-1.39A7.32,7.32,0,0,0,52.6,32a1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4A7.3,7.3,0,0,0,59,36a1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 55.8,
    cy: 32.99,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 22.2, 88.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.3,36.83h0c0-.53-.62-1.06-1.7-1.39a7.32,7.32,0,0,0-5.35.41,1.19,1.19,0,0,0-.66,1h0V38.9h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 62.45,
    cy: 36.83,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 24.94, 98.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.33,24h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 27.48,
    cy: 24.02,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(3.16 51.24) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38,27.86h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 34.13,
    cy: 27.86,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(5.9 61.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.63,31.7h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4A7.33,7.33,0,0,0,44,34.75a1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 40.78,
    cy: 31.7,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(8.64 72.14) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.28,35.54h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 47.43,
    cy: 35.54,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(11.38 82.58) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.93,39.38h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 54.08,
    cy: 39.38,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(14.11 93.03) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.75 24.76 53.2 39.88 53.2 93.88 99.75 78.76 99.75 24.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.3 16.85 53.2 39.88 53.2 93.88 13.3 70.85 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "33.25 34.36 46.55 42.04 46.55 54.04 33.25 46.36 33.25 34.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 53.2,
    y1: 39.88,
    x2: 53.2,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "99.75 78.76 53.2 93.88 13.3 70.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 99.75,
    y1: 24.76,
    x2: 99.75,
    y2: 78.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 59.85,
    y1: 1.72,
    x2: 99.75,
    y2: 24.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "53.2 39.88 99.75 24.76 113.05 44.44 66.5 59.56 53.2 39.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "13.3 16.85 53.2 39.88 39.9 56.2 0 33.17 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "79.8 7.24 59.85 1.72 99.75 24.76 119.7 30.27 79.8 7.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "46.48 0 59.85 1.72 13.3 16.85 0 15.17 46.48 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion",
    "data-name": "Fyldning & Inspektion"
  }, /*#__PURE__*/React.createElement("use", {
    width: 119.7,
    height: 94.43,
    xlinkHref: "#BoxOpen_02a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpen2);
export default __webpack_public_path__ + "static/media/box-open-2.cc3f9b1c9fd4c8c219fa73f77899278a.svg";
export { ForwardRef as ReactComponent };